import React from "react";
import {
  BarChart,
  Bar,
  Legend
} from "recharts";

const data = [
  {
    Y1: 94000,
    Y2: 92400,
    Y3: 92400
  },
  {
    Y1: 84000,
    Y2: 72400,
    Y3: 632400
  },
  {
    Y1: 4000,
    Y2: 72400,
    Y3: 632400
  },
  {
    Y1: 840500,
    Y2: 72400,
    Y3: 632400
  },
  {
    Y1: 845000,
    Y2: 72400,
    Y3: 632400
  },
  {
    Y1: 854000,
    Y2: 72400,
    Y3: 632400
  },
  {
    Y1: 845000,
    Y2: 72400,
    Y3: 62400
  },
  {
    Y1: 844000,
    Y2: 72400,
    Y3: 632400
  },
];

export default function App() {
  return (
    <BarChart
      width={200}
      height={120}
      data={data}
      margin={{
        top: 20,
        right: 30,
        left: 20,
        bottom: 5
      }}
    >
      <Legend iconType={"circle"} iconSize={8}  wrapperStyle={{position: 'relative', }} />
      <Bar dataKey="Y1" stackId="a" fill="#263238" />
      <Bar dataKey="Y2" stackId="a" fill="#FCA000" />
      <Bar dataKey="Y3" stackId="a" fill="#FFC500" />
    </BarChart>
  );
}
